import { useEffect, useState } from "react";

export const useSelectedFilterOptionsState = (selectedOptions, options, active) => {
  const [selectedOptionsState, setSelectedOptions] = useState(
    selectedOptions?.map((x) => x.id) ?? []
  );

  const onOptionSelected = (id) => {
    if (selectedOptionsState.includes(id)) {
      setSelectedOptions(selectedOptionsState.filter((x) => x !== id));
    } else if (options.some((x) => x.id === id)) {
      setSelectedOptions([...selectedOptionsState, id]);
    }
  };

  const onSelectAll = (rows) => {
    const selectedLength = rows.filter((row) => row.selected)?.length;
    const isAllSelected = rows?.length === selectedLength;

    const result = isAllSelected ? [] : selectedLength === 0 ? rows : [];

    setSelectedOptions(result.map((row) => row.id));
  };

  useEffect(() => {
    setSelectedOptions(selectedOptions?.map((x) => x.id));
  }, [active]);

  return { selectedOptionsState, setSelectedOptions, onOptionSelected, onSelectAll };
};
